import Overlay from "../../../Componentes/Overlay"
import SideMenu from "../../../Componentes/SideMenu"
import SideMenuBtn from "../../../Componentes/SideMenuBtn";
import { useModal } from "../../../contexts/ModalContext"

const SidebarAditivos = () => {

    const { closeModal, openModal } = useModal();

    const handleOpenModal = () => {

        closeModal();
        openModal("modalNovoAditivo");

    }

    return(
        <>
            <Overlay state={ true } changeContent={ closeModal } >
                <SideMenu>
                    <SideMenuBtn
                        button="NOVO ADITIVO"
                        clickFunc={ handleOpenModal }
                    />
                </SideMenu>
            </Overlay>
        </>
    )
}

export default SidebarAditivos;